// @flow
import React from 'react';
import { usePropsValidation } from './validation/runtime-checks/index.js';
import type { ComponentWithSpecification } from './types.js';

function withValidation<Config, Instance>(
  Component: ComponentWithSpecification<Config>,
) {
  const Wrapper = React.forwardRef<Config, Instance>((props, ref) => {
    // TODO this usePropsValidation might be a useless abstraction if
    // the only way we leverage this is inside this withValidation HoC
    const { failedValidation } = usePropsValidation(props, Component);
    if (failedValidation) return null;
    // TODO it would be good to remove all the compiler-injected _props before forwarding
    // but we currently sometime rely on the _performValidation property when
    // doing ad-hoc assertions.
    return <Component ref={ref} {...props} />;
  });
  Wrapper.displayName = `withValidation(${
    Component.displayName || Component.name || 'Anonymous'
  })`;
  // This property signals to the spec system that it should treat this wrapper
  // component as the wrapped component for the purpose of spec checking.
  Wrapper.__wrappedComponent = Component;
  return Wrapper;
}

export default withValidation;
